import React from "react";
import { Popup as Modal } from "reactjs-popup";
import Button from "../../../../components/Button";
import { CSVDownload } from "react-csv";
import { serviceRequestCsvHeaders as headers } from "../../../../services/csv/serviceRequestCsvHeaders";
import { useDispatch, useSelector } from "react-redux";
import { fetchSelectedServiceRequestCSVExportDownloadList, fetchSelectedServiceRequestPDFExportDownloadList } from "../../../../store/actions/csvExport";
import { toast } from "react-toastify";
import { selectAuthenticatedUser } from "../../../../store/selectors/auth";

export const DownloadOverlay = ({
  showDownloadOverlay,
  setShowDownloadOverlay,
  serviceRequestIds,
}) => {
  const {loadingDone, serviceRequestList} = useSelector(state=>state.csvExport)
  const user = useSelector(selectAuthenticatedUser);
  const dispatch = useDispatch();
  const downloadCSV = () => {
    setShowDownloadOverlay(false);
    dispatch(fetchSelectedServiceRequestCSVExportDownloadList(serviceRequestIds));
  };
  const downloadPDF = () => {
    setShowDownloadOverlay(false);
    dispatch(fetchSelectedServiceRequestPDFExportDownloadList(user.id, serviceRequestIds.join('&')))
      .then(res=>res?.json())
      .then(res=>toast.success(res.message))
  };
  return (
    <>
      <Modal
        open={showDownloadOverlay}
        onClose={() => setShowDownloadOverlay(false)}
        closeOnDocumentClick={true}
        className="popup-content"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            gap: "1rem",
          }}
        >
          <Button
            color="teal"
            label="CSV download"
            size="tiny"
            onClick={() => downloadCSV()}
          />

          <Button
            color="teal"
            label="PDF download"
            size="tiny"
            onClick={() => downloadPDF()}
          />
        </div>
      </Modal>
      {loadingDone === true && (
        <CSVDownload
          data={serviceRequestList}
          headers={headers}
          filename="ServiceRequests.csv"
          target="_blank"
        />
      )}
    </>
  );
};
